import { Form, Formik } from "formik";
import type React from "react";
import CreateButton from "../../../components/Modals/CreateButton.tsx";
import { Button } from "../../../components/Theme/button.tsx";
import { Col, Container } from "../../../components/Theme/grid.tsx";
import { type IssueCategories, issueCategoriesEnum } from "../../../kubb";
import ManualIssueCategorySelect from "./ManualIssueCategorySelect.tsx";

interface ManualIssueFormProps {
  submit: (values: ManualIssueFormValues) => Promise<any>;
  cancel: () => void;
  invalid?: boolean;
  count?: number;
}

export interface ManualIssueFormValues {
  category: IssueCategories;
}

export default function ManualIssueForm(
  props: ManualIssueFormProps,
): React.ReactElement {
  const { count = 1 } = props;
  return (
    <Formik
      onSubmit={props.submit}
      initialValues={{ category: issueCategoriesEnum["MANUAL.NOT_ADOPTED"] }}
    >
      {({ resetForm, isValid, isSubmitting }) => (
        <Form>
          <Container>
            <Col sm={12}>
              <ManualIssueCategorySelect
                fieldName={"category"}
                label={{ label: "Category", size: "sm" }}
              />
            </Col>
            <Col sm={12}>
              <div className={"flex flex-row-reverse gap-2"}>
                <CreateButton
                  disabled={props.invalid || !isValid}
                  loading={isSubmitting}
                  type={"submit"}
                  labelText={`Create ${count} issue${count !== 1 ? "s" : ""}`}
                />
                <Button
                  color={"red"}
                  onClick={() => {
                    resetForm();
                    props.cancel();
                  }}
                >
                  Cancel
                </Button>
              </div>
            </Col>
          </Container>
        </Form>
      )}
    </Formik>
  );
}
